import React from "react";
import { FC } from "react";
import { FieldProps } from "react-final-form";
import { Field as FFField } from "react-final-form";

const Field: FC<FieldProps<any, any>> = (props) => {
  return <FFField {...props} />;
};

export default React.memo(Field);
